export enum NewsTypes{
    All = 0,
    BEEngaged = 1
}